import md5 from 'js-md5'
import host from '@host'
import axios from 'axios'
import qs from 'qs'

const createForm = function (params) {
    const form = new FormData()
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const value = params[key]
            form.append(key, value)
        }
    }
    return form
}

class Request {
    static post(url, params) {
        const timestamp = new Date() * 1
        const platform = 8
        const sign = md5('platform=' + platform + '&timestamp=' + timestamp)

        return new Promise((resolve, reject) => {
            if (window.fetch) {
                fetch(host.domain + url, {
                        method: 'POST',
                        mode: 'cors',
                        credentials: 'include',
                        headers: {},
                        body: createForm({
                            platform,
                            sign,
                            timestamp,
                            ...params
                        })
                    })
                    .then(response => {
                        return response.json()
                    })
                    .then(data => {
                        if (data.token) {
                            localStorage.setItem('token', response.data.token);
                        }
                        resolve(data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            } else {
                axios({
                    method: 'post',
                    url: host.domain + url,
                    data: createForm({
                        platform,
                        sign,
                        timestamp,
                        ...params
                    }),
                    headers: {}
                }).then((response) => {
                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                    }
                    resolve(response.data)
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            }
        })
    }
    static get(url, params) {
        return new Promise((resolve, reject) => {
            if (window.fetch) {
                fetch(host.domain + url + '?' + qs.stringify(params), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include',
                        headers: {},
                    })
                    .then(response => {
                        return response.json()
                    })
                    .then(data => {
                        if (data.token) {
                            localStorage.setItem('token', response.data.token);
                        }
                        resolve(data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            } else {
                axios({
                    method: 'get',
                    url: host.domain + url,
                    params,
                    headers: {}
                }).then((response) => {
                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                    }
                    resolve(response.data)
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            }
        })
    }
}

export default Request